import { ready } from './helpers';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger)

ready().then(() => {
    gsap.from('.entry-content h2, .wp-block-group', {
        scrollTrigger: {
            trigger: '.wp-block-group',
            start: 'top 80%',
            toggleActions: 'play none none none'
        },
        stagger: 0.3,
        y: 100,
        opacity: 0,
        ease: "power3.out",
        duration: 1.3
    })

    gsap.from('.content-area, .widget-area > section', {
        stagger: 0.3,
        y: 100,
        opacity: 0,
        ease: "power3.out",
        duration: 1.3
    })

})
